import { useWindowDimensions } from 'react-native'

const DEFAULT_MOBILE_WIDTH_THRESHOLD = 768

export function useMobileLayout(): boolean {
  const { width: windowWidth } = useWindowDimensions()
  return windowWidth < DEFAULT_MOBILE_WIDTH_THRESHOLD
}
